import React from 'react'
import './EmptyState.styles.css'

interface EmptyStateProps {
  icon?: string
  title: string
  description: string
  className?: string
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📋',
  title,
  description,
  className = ''
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-description">{description}</p>
    </div>
  )
}

export default EmptyState
